import React from "react";
import { WHOLESALE_COMMODITIES } from "../../mock";

export default function StepReview({ selected, lines, details }) {
  const items = WHOLESALE_COMMODITIES.filter((c) => selected.includes(c.id));
  return (
    <div data-testid="step-review">
      <h2 className="font-display text-3xl md:text-5xl font-light leading-[1.05] text-[#10271a]">
        One last <em className="italic text-[#1f4a33]">look.</em>
      </h2>
      <p className="mt-4 text-[#5e6b61] text-lg max-w-xl">Here's what we'll send to the trade desk.</p>

      <div className="mt-10 rounded-3xl border border-[#10271a]/10 overflow-hidden">
        <div className="bg-[#10271a] text-[#f6f1e7] px-6 md:px-8 py-4 text-[11px] tracking-[0.2em] uppercase">Requested supply</div>
        <ul className="divide-y divide-[#10271a]/10 bg-[#fbf8f1]">
          {items.map((c) => {
            const l = lines[c.id];
            return (
              <li key={c.id} className="px-6 md:px-8 py-5 grid grid-cols-1 md:grid-cols-[1.4fr_1.6fr_1fr_1fr] gap-2 md:gap-6 items-center" data-testid={`review-line-${c.id}`}>
                <div>
                  <p className="font-display text-2xl text-[#10271a] leading-none">{c.name}</p>
                  <p className="text-xs text-[#5e6b61] mt-1">{c.origin}</p>
                </div>
                <p className="text-[#10271a]">{l.grade}</p>
                <p className="text-[#10271a] font-medium tabular-nums">{l.volume} {l.unit}</p>
                <p className="text-[#5e6b61] text-sm">{l.frequency}</p>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-6 rounded-3xl border border-[#10271a]/10 bg-[#fbf8f1] px-6 md:px-8 py-6 grid grid-cols-2 md:grid-cols-4 gap-6 text-sm" data-testid="review-details">
        <Cell label="Company" value={details.company} />
        <Cell label="Contact" value={`${details.name} · ${details.email}${details.phone ? ` · ${details.phone}` : ""}`} />
        <Cell label="Destination" value={`${details.country}${details.port ? ` · ${details.port}` : ""}`} />
        <Cell label="Terms" value={`${details.buyerType} · ${details.incoterm}`} />
        {details.notes && <div className="col-span-2 md:col-span-4"><Cell label="Notes" value={details.notes} /></div>}
      </div>
      <p className="mt-5 text-xs text-[#5e6b61]">Your enquiry is sent to our trade desk and a copy is emailed to you.</p>
    </div>
  );
}

function Cell({ label, value }) {
  return (
    <div>
      <p className="text-[11px] tracking-[0.18em] uppercase text-[#7c5230] mb-1">{label}</p>
      <p className="text-[#10271a] break-words">{value}</p>
    </div>
  );
}
